import { render, staticRenderFns } from "./InformationPageDetails.vue?vue&type=template&id=70039612&"
import script from "./InformationPageDetails.vue?vue&type=script&lang=ts&"
export * from "./InformationPageDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPageDetails.vue?vue&type=style&index=0&id=70039612&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports